// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__-uaqM","loader--svg":"Loader_loader--svg__1hf+A"};